let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let Constants = require("../../../../../utils/Constants");
let ProOnly = require("../../../../widgets/ProOnly");
let FormUtils = require("../../../../../utils/FormUtils");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let createStandardEventForm = require("../../createStandardEventForm");
let isEventAccountingLockedForMe = require("../../../../../utils/isEventAccountingLockedForMe");

module.exports = createStandardEventForm({
  eventToInitialValues(event) {
    let d = _.get(event, "key_values.CONTRACT_EXECUTION_DATE", null);
    d = !_.isEmpty(d) ? esUtils.convertFromISO8601(d) : d;
    return {
      speechTitle: event.speechTitle || "",
      dress: event.dress || "",
      audienceSize: event.audienceSize || "",
      source: event.source || "",
      NCSID: esUtils.getIn(event, ["key_values", "NCSID"]) || "",
      contract_execution_date: d,
      flag_author: _.get(event, ["flags_as_map", "author", "is_set"], false),
      flag_temporary: _.get(
        event,
        ["flags_as_map", "temporary", "is_set"],
        false
      ),
      publicInvited: !!event.publicInvited,
      offerPending: !!event.offerPending,
      presentingproductid: event.presentingproductid,
    };
  },
  buildSchema({ event, Displaylists, is_limited_speaker }) {
    let event_speakers = _.filter(
      Displaylists && Displaylists.perspeaker,
      function (spkr) {
        return _.includes(event && event.sids, spkr.sid);
      }
    );
    let presentations = _.sortBy(
      _.uniq(_.flattenDeep(_.map(event_speakers, "presentations"))),
      function (p) {
        return p.trim().toLowerCase();
      }
    );
    let event_sources = _.sortBy(
      _.uniq(
        _.map(_.flattenDeep(_.map(event_speakers, "event_sources")), "source")
      ),
      function (s) {
        return s.trim().toLowerCase();
      }
    );
    let schema = {
      speechTitle: {
        label: "Presentation Title",
        type: "combo",
        read_only: isEventAccountingLockedForMe(event),
        options: _.object(
          _.map(presentations, function (presentation) {
            return [presentation, presentation];
          })
        ),
        validate: FormUtils.v.optional,
      },
      dress: {
        label: "Dress",
        type: "text",
      },
      audienceSize: {
        label: "Audience Size",
        type: "text",
      },
      source: {
        label: "Lead Source",
        type: "combo",
        options: _.object(
          _.map(event_sources, function (source) {
            return [source, source];
          })
        ),
      },
      publicInvited: {
        label: "Public Invited",
        type: "checkbox",
      },
      offerPending: {
        label: "Offer Pending",
        type: "checkbox",
      },
    };

    if (AuthedUserSession.is_st_family) {
      let presentationcategories, presentingproduct;

      if (AuthedUserSession.is_st_family) {
        presentationcategories = _.map(
          _.get(
            Displaylists,
            ["universal", "presentationcategory", event.companyID],
            []
          ),
          function ({ id, name, flags }) {
            flags = parseInt(flags, 10);
            if (
              (flags & Constants.PRESENTATION_CATEGORY_FLAGS.ARCHIVED) > 0 &&
              parseInt(id, 10) !== parseInt(event.speechTitle, 10)
            )
              return null; //exclude items marked as "archive" (flag 1) unless it is this event's value
            return [id, name];
          }
        );
        presentationcategories = presentationcategories.filter(function (el) {
          return el != null; //remove the entries that got filtered out by making them null above
        });

        presentingproduct = _.get(
          Displaylists,
          ["universal", "presentingproduct", event.companyID],
          []
        );
        presentingproduct = _.map(
          _.filter(presentingproduct, (p) => {
            return p.archived === 0 || p.id === event.presentingproductid;
          }),
          function ({ id, description }) {
            return [id, description];
          }
        );
      } else {
        //ST family brands not yet converted to the 2020 team admin code
        presentationcategories = _.map(
          _.get(Displaylists, "universal.presentationcategory", {}),
          function ({ id, name }) {
            return [id, name];
          }
        );
        presentingproduct = _.filter(
          _.map(
            _.get(Displaylists, ["universal", "presentingproduct"], []),
            function ({ id, companyid, description }) {
              return event.companyID === companyid ? [id, description] : null;
            }
          )
        );
      }

      schema.speechTitle = {
        label: "Pres Category",
        type: "select",
        options: _.object(presentationcategories),
        read_only: isEventAccountingLockedForMe(event),
        validate: FormUtils.v.optional,
      };
      schema.presentingproductid = {
        label: "Product",
        type: "select",
        options: _.object(presentingproduct),
        read_only: isEventAccountingLockedForMe(event),
        validate: FormUtils.v.optional,
      };
      schema.NCSID = {
        label: "NCSID",
        type: "text",
      };
      schema.contract_execution_date = {
        label: "Contract Execution",
        type: "date",
        validate: FormUtils.v.optional,
      };
      schema.flag_author = {
        label: "Author",
        type: "checkbox",
      };
      schema.flag_temporary = {
        label: "Temporary Date",
        type: "checkbox",
      };
      schema.offerPending.label = "Ignore Product";

      if (is_limited_speaker) {
        delete schema.speechTitle;
        delete schema.presentingproductid;
        delete schema.NCSID;
        delete schema.source;
        delete schema.contract_execution_date;

        schema.flag_temporary.read_only = true;
        schema.flag_author.read_only = true;
        schema.offerPending.read_only = true;
        schema.publicInvited.read_only = true;
        schema.audienceSize.read_only = true;
      }
    } else if (AuthedUserSession.is_privatelabel) {
      if (is_limited_speaker) {
        delete schema.speechTitle;
        delete schema.source;

        schema.offerPending.read_only = true;
        schema.publicInvited.read_only = true;
        schema.audienceSize.read_only = true;
      }
    }

    return schema;
  },
  writeInputDataToEvent(data, event) {
    event.speechTitle = data.speechTitle;
    event.dress = data.dress;
    event.audienceSize = data.audienceSize;
    event.source = data.source;
    event.publicInvited = !!data.publicInvited;
    event.offerPending = !!data.offerPending;

    if (AuthedUserSession.is_st_family) {
      event.presentingproductid = esUtils.toInt(data.presentingproductid);

      event.flags_as_map.author.is_set = !!data.flag_author;
      event.flags_as_map.temporary.is_set = !!data.flag_temporary;

      if (!_.isPlainObject(event.key_values)) {
        event.key_values = {};
      }
      event.key_values.NCSID = data.NCSID;
      event.key_values.CONTRACT_EXECUTION_DATE = _.isDate(
        data.contract_execution_date
      )
        ? esUtils.returnISO8601(data.contract_execution_date)
        : data.contract_execution_date; //this way the Z is cut off the end to avoid timezone problems
    }
  },
  renderFields() {
    return dd.div(
      null,
      ezHorizontalFields(this, [["speechTitle"], ["dress"], ["audienceSize"]]),
      ProOnly(
        { sids: this.props.event.sids },
        ezHorizontalFields(this, [["source"]])
      ),
      ezHorizontalFields(this, [
        ["presentingproductid"],
        ["NCSID"],
        ["contract_execution_date"],
        ["flag_author"],
        ["flag_temporary"],
        ["publicInvited"],
        ["offerPending"],
      ])
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/misc/MiscForm.js